const build = (settings) => [
  {
    required: settings,
  },
];

export default build;
